/**
 * Event name when the dropdown is changed
 */
export const AD_CONVERSION_EVENT = 'adConversionEvent';
